module.exports = __webpack_public_path__ + "static/media/sonya_surapaneni.a45efe33.png";